import { Select } from '@cimpress/react-components';
import React, { useEffect, useState } from 'react';
import { ValueType } from 'react-select';
import { ShipmentStatus } from '../../../ports/ShipmentsService';

// tslint:disable-next-line:variable-name
const ShipmentStatusLabels = {
  [ShipmentStatus.UNSORTED]: 'Unsorted',
  [ShipmentStatus.SORTED]: 'Sorted',
  [ShipmentStatus.MANIFESTED]: 'Manifested',
  [ShipmentStatus.VOIDED]: 'Voided',
};

function createStatusOption(status: ShipmentStatus) {
  return {
    value: status,
    label: ShipmentStatusLabels[status],
  };
}

export interface StatusFilterProps {
  onChange: (value: ShipmentStatus[]) => void;
}

// tslint:disable-next-line:function-name
export default function StatusFilter(
  {
    onChange,
  }: StatusFilterProps,
) {
  const [status, setStatus] = useState<ShipmentStatus[]>([]);

  const updateStatus = (values: ValueType<{ value: string; label: string; }>) => {
    if (Array.isArray(values)) {
      setStatus(values.map(v => v.value as ShipmentStatus));
    } else {
      setStatus([]);
    }
  };

  useEffect(() => onChange(status), [status]);

  return <>
    <h6>Shipment Status</h6>
    <Select
      options={Object.values(ShipmentStatus).map(createStatusOption)}
      isMulti
      value={status.map(createStatusOption)}
      onChange={updateStatus}
    />
  </>;
}
